<template>
	<div id="app">


		<HNB single-title="产品介绍视频"></HNB>
		<div style="max-height: 16.5rem; overflow: hidden; display: flex; justify-content: center; align-items: center;">
			<img style="width: 100%; " :src="img1">
		</div>
		<div id="main">
			<div class="sqbox">
				<div class="sqbox1">
					<div class="span1"><strong>产品介绍视频</strong></div>
					<!-- <div class="svg">
						<SvgIcon svg-name="search" size="12"></SvgIcon>
					</div>
					<div class="span2">搜索相关产品</div> -->
				</div>
				<div class="sqbox2">
					<ul>

						<li v-for="(item,i) in Mimgs" :key="i" @click="open(item.video_link)">
							<div id="Model">

								<div class="imgs" style="position: relative;">
									<img class="amplification_1_3" style="width: 4.125rem;" :src="item.product_img">
									<img style="width: 40px;position: absolute;left:3%;top: 3%;" :src="item.product_honor_img">
									<!-- <SvgIcon :svg-name="item.svgName" size="40" style='position: absolute;left:3%;top: 3%;'></SvgIcon> -->
								</div>
								<div class="explain">
									<slot name="letter">{{item.product_name}}</slot>
								</div>
								<!-- <div class="write1">
										DOWNLOAD
									</div> -->

							</div>

						</li>

					</ul>
				</div>
			</div>

		</div>
		<BS :BsTitle="bsTitle"></BS>

		<dialog-bar v-model="sendVal" type="confirm" title="" :content="tips" v-on:cancel="clickCancel()" @danger="clickDanger()"
		 @confirm="clickConfirm()" dangerText="Delete"></dialog-bar>

	</div>
</template>

<script>
	import SvgIcon from '../components/SvgIcon.vue'
	import HNB from '../components/HeaderNavigationBar.vue'
	import BS from '../components/bottomShow.vue'
	import dialogBar from '../components/dialog.vue'
	import request from '../common/request.js'
	export default {
		name: "app",
		components: {
			HNB,
			SvgIcon,
			BS,
			'dialog-bar': dialogBar
		},
		data() {
			return {
				tips: '',
				sendVal: false,
				Mimgs: [
					// {
					// 	svgName: 'goodDesign',
					// 	img: this.GLOBAL.imgHost + '/images/eye.png',
					// 	letters: '乐范灵眸眼部按摩仪',
					// 	arr: [
					// 		''
					// 	]
					// }, 
					// {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/bear.png',
					// 	letters: '乐范随身魔力按摩贴',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=E9tlvUDybE&banner_id=f.79991533~image_ad.1~3~e1tjHBnt&reft=1591413329342&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/magicsticker.png',
					// 	letters: '乐范四驱魔力贴熔岩黑',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=zivwz0wklD&banner_id=f.79991533~image_ad.1~3~ZQvaj413&reft=1591413389840&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/egg.png',
					// 	letters: '乐范小摩蛋粉色',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=nMv0ksVSHY&banner_id=f.79991533~image_ad.1~1~LE3gsfIi&reft=1591413480866&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/claw.png',
					// 	letters: '乐范小摩爪珊瑚粉',
					// 	arr: ['']
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/eyes.png',
					// 	letters: '乐范眼部冷热按摩仪',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=RKVQ7vIvRs&banner_id=f.79991533~image_ad.1~2~Lu38l78I&reft=1591413688886&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/shapecushion.png',
					// 	letters: '乐范塑形坐垫',
					// 	arr: ['']
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/moxibustion.png',
					// 	letters: '艾灸棒',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=4BycUWBJOJ&banner_id=f.79991533~image_ad.1~1~Nl0Ch2kL&reft=1591413748999&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/neckpillow.png',
					// 	letters: '乐范按摩助眠颈枕',
					// 	arr: ['']
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/massagechair.png',
					// 	letters: '按摩椅焦糖黄',
					// 	arr: ['']
					// }, {
					// 	svgName: 'IF',
					// 	img: this.GLOBAL.imgHost + '/images/neckmassager.png',
					// 	letters: '颈部揉捏按摩仪',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=nUcva7DJYj&banner_id=f.79991533~image_ad.1~6~QDsGGR5l&reft=1591414666922&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/cappa.png',
					// 	letters: '乐范3D揉捏披肩',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=96Z0iltj55&banner_id=f.79991533~image_ad.1~4~uw8YS0ft&reft=1591414651597&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/cushion.png',
					// 	letters: '乐范背部按摩椅垫',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=weWmCXFQe6&banner_id=f.79991533~image_ad.1~4~QC8mqZNq&reft=1591414635417&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/footmassager.png',
					// 	letters: '乐范脚部揉捏按摩器',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=k8CtKmFC4A&banner_id=f.79991533~image_ad.1~2~b1IsxZha&reft=1591414587092&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: 'IF',
					// 	img: this.GLOBAL.imgHost + '/images/back.png',
					// 	letters: '人机工学背靠',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=U3ccaCzI8w&banner_id=f.79991533~image_ad.1~6~BO7PZtqG&reft=1591414609583&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: 'goodDesign',
					// 	img: this.GLOBAL.imgHost + '/images/desk.png',
					// 	letters: '升降桌',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=08xZyF3tgO&banner_id=f.79991533~image_ad.1~3~td2do3Wf&reft=1591414707473&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/legmaddager.png',
					// 	letters: '腿部按摩器',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=oUXt3EE3Cl&banner_id=f.79991533~image_ad.1~5~e9pP9nDo&reft=1591414809672&spm=f.79991533'
					// 	]
					// }, {
					// 	svgName: '',
					// 	img: this.GLOBAL.imgHost + '/images/footbath.png',
					// 	letters: '折叠足浴盆',
					// 	arr: [
					// 		'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=Q5qmwPw4Mp&banner_id=f.79991533~image_ad.1~5~1gQOjY27&reft=1591414789961&spm=f.79991533'
					// 	]
					// },
				],
				bsTitle: ['服务支持', '产品介绍视频'],
				img1: this.GLOBAL.imgHost + '/images/background.png',
				// arr:['https://shop41582539.m.youzan.com/v2/feature/3Lz6O4THEV']
			}
		},
		mounted() {
			this.getProducList()
		},
		methods: {
			open(url) {
				// console.log(url);
				// console.log(this.arr);
				if (url) {
					window.open(url)
				} else {
					// alert("视频正在更新中！");
					this.openMask("视频正在更新中！");
				}
			},

			openMask(text) {
				this.sendVal = true;
				this.tips = text;
			},
			clickCancel() {
				console.log('点击了取消');
			},
			clickDanger() {
				console.log('这里是danger回调')
			},
			clickConfirm() {
				console.log('点击了confirm');
			},
			async getProducList() {
				// 获取数据
				// request.uniRequest('/product/getProductList')
				// 	.then(res => {
				// 		console.log('成功了吗productList', res)
				// 		this.Mimgs = res.data
				// 	}).catch(e => {})
				let res = await this.$Cloud.table(`lf_func_lefan_product`).get({ page: 0, pageSize: 1000 })
				
				console.log('获取商品列表',res)
				
				const {code,data} = res
				if(code == 200) {
					this.Mimgs = data.filter(item=>item.is_check==2)
				}
				
			},
		}

	}
</script>

<style>
	#main {
		width: 100%;
		margin-top: 5%;
	}

	#main .sqbox {
		width: 60rem;
		height: 40.25rem;
		margin: 0 auto;

	}

	#main .sqbox .sqbox1 {
		width: 100%;
		height: 2.5rem;
		font-size: 1rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 500;
		color: rgba(24, 24, 24, 1);
		line-height: 1.875rem;
		margin-top: 2.8125rem;

	}

	#main .sqbox .sqbox1 .span1 {

		float: left;
	}

	#main .sqbox .sqbox1 .svg {
		float: left;
		position: relative;
		left: 78%;
		color: rgba(120, 120, 120, 1);
		cursor: pointer;
	}

	#main .sqbox .sqbox1 .span2 {

		font-size: 0.8125rem;

		font-weight: 400;
		color: rgba(120, 120, 120, 1);
		line-height: 1.875rem;
		position: relative;
		left: 79%;
		float: left;
		text-decoration: underline;
		cursor: pointer;
	}

	#main .sqbox .sqbox2 {
		width: 100%;
		height: 37.5rem;
		/* position: relative;
		left: 80%;
		top: -5%; */
	}

	#main .sqbox .sqbox2 ul {
		width: 100%;
		height: 37.5rem;
		position: relative;
		/* left: -6%; */
	}

	#main .sqbox .sqbox2 ul li {
		list-style: none;
		float: left;
	}

	#main .sqbox .sqbox2 span {
		width: 5.0625rem;
		height: 0.625rem;
		font-size: 0.825rem;

		font-weight: 400;
		color: rgba(120, 120, 120, 1);
		line-height: 1.875rem;
	}

	#Model {
		width: 10rem;
		height: 15rem;
		cursor: pointer;

	}

	#Model .imgs {
		width: 9.5rem;
		height: 9.5rem;
		background: rgba(244, 244, 244, 1);
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#Model .explain {

		font-size: 0.8rem;

		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		line-height: 1.3125rem;
		margin: 0 auto;
		margin-top: 0.625rem;
	}

	#Model .write1 {
		font-size: 0.75rem;

		font-weight: 400;
		text-decoration: underline;
		color: rgba(0, 199, 133, 1);
		line-height: 0.5625rem;
		margin: 0 auto;
		margin-top: 0.625rem;

	}
</style>
